export default {
  label: "Gestión de Flota",
};
